import { render, staticRenderFns } from "./FeedEdit.vue?vue&type=template&id=27287d2e&scoped=true&"
import script from "./FeedEdit.vue?vue&type=script&lang=js&"
export * from "./FeedEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27287d2e",
  null
  
)

export default component.exports